/**
 * Verify Email Route
 *
 * Integrates with existing VerifyEmailPage component from Story 1.3.
 */

import { createFileRoute } from "@tanstack/react-router";
import { VerifyEmailPage } from "../../pages/auth/VerifyEmail";

export const Route = createFileRoute("/_auth/verify-email")({
  component: VerifyEmailRoute,
});

function VerifyEmailRoute() {
  // API base URL - empty string uses same origin
  return <VerifyEmailPage apiBaseUrl="" />;
}
